import { render, staticRenderFns } from "./Notice.vue?vue&type=template&id=598a402a&"
import script from "./Notice.vue?vue&type=script&setup=true&lang=js&"
export * from "./Notice.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Notice.vue?vue&type=style&index=0&id=598a402a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports